import dynamic from "next/dynamic";
 
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
 
import { getDataByUrl } from "@/handlers/commonApi";
import useIsMobile from "@/hooks/useIsMobile";
import { stateData } from "@/constants/electionConfig";
// import OldElectionScreen from "@/screens/OldStateElection";
const OldElectionScreen = dynamic(() => import("@/screens/OldStateElection"));

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
}) {
  const isMobileDevice = useIsMobile();
   
  // const oldDesc =
  //   "Maharashtra Assembly Elections Results 2024: इस बार के महाराष्ट्र विधानसभा चुनाव में कौन मारेगा बाजी? BJP, शिवसेना (शिंदे गुट) और NCP (अजित गुट) का महायुति गठबंधन को मिलेगा बहुमत या कांग्रेस, शिवसेना (उद्धव गुट) और NCP (शरद गुट) वाला महाअघाड़ी गठबंधन दोहराएगा 2024 लोकसभा चुनाव का प्रदर्शन? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ. नीचे दी गई लिस्ट में जानिए 2019 के महाराष्ट्र विधानसभा चुनाव का रिजल्ट क्या रहा था.";
  // const newDesc =
  //   "Maharashtra Assembly Elections Results 2024: इस बार के महाराष्ट्र विधानसभा चुनाव में कौन मारेगा बाजी? BJP, शिवसेना (शिंदे गुट) और NCP (अजित गुट) का महायुति गठबंधन को मिलेगा बहुमत या कांग्रेस, शिवसेना (उद्धव गुट) और NCP (शरद गुट) वाला महाअघाड़ी गठबंधन दोहराएगा 2024 लोकसभा चुनाव का प्रदर्शन? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ. ";
  // let metaData = {
  //   title: `Maharashtra Election Results 2024 | महाराष्ट्र विधानसभा चुनाव परिणाम | Maharashtra Assembly Elections 2024 - NewsTak.in`,
  //   description: `Maharashtra Vidhan Sabha Election 2024 Results: Find the Maharashtra Assembly Election Results 2024 on NewsTak.in, including election result updates, महाराष्ट्र विधानसभा चुनाव परिणाम 2024, live vote counting, चुनाव विश्लेषण, वोटों की गिनती, चुनाव समाचार, पार्टी परिणाम, वीडियो, फोटो, विजेता उम्मीदवारों, and विधानसभा चुनाव नतीजे का कवरेज.`,
  //   keywords: `elections, election results, Maharashtra Assembly election results, maharashtra vidhan sabha chunav result, Maharashtra election results, Maharashtra election results live, Maharashtra assembly Election 2024 Result, counting of votes for Maharashtra Assembly Election, constituency wise result, Maharashtra election results, congress results updates, महाराष्ट्र विधानसभा चुनाव, 2024 महाराष्ट्र विधानसभा चुनाव परिणाम, चुनाव परिणाम, महाराष्ट्र चुनाव परिणाम, चुनाव 2024, विधानसभा चुनाव 2024 परिणाम,`,
  // };
  const state_data = stateData[electionCategory];
  
  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
         
        <OldElectionScreen
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}

          electionPath={`${electionCategory}/results`}
          isMobileDevice={isMobileDevice}
          masterKey={state_data?.masterConfigKey} //"delhi_election"
          electionPassedCategory={state_data?.["results"]?.electionPassedCategory} //'delhi-assembly'
          stateName={state_data?.["results"]?.state} //"Delhi"
          stateHindi={state_data?.["results"]?.stateHindi} //"महाराष्ट्र"
          metaData={state_data?.["results"]?.metaData}
          oldResult={state_data?.["results"]?.oldResult}
          oldDesc={state_data?.["results"]?.oldDesc}
          newDesc={state_data?.["results"]?.newDesc}
          resultKey={state_data?.["results"]?.resultKey}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  const electionCategory = ctx?.params?.stateElection; //ctx?.params?.category === "election";
  let url = ctx?.resolvedUrl;
  url = url.split("/results")[0];
  if (!electionCategory) {
    return {
      notFound: true,
    };
  }
  const { stateData } = await import("@/constants/electionConfig");
 
  if(!stateData[electionCategory]){
    // console.log("stateData", stateData);
    return {
      notFound: true,
    };
  }
  try {
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let masterConfigData = await getMasterConfig();

    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory,
        // faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
